<template>
  <div>
    <div class="panel-subtitle bottom-margin">
      Payment preferences
    </div>

    <div class="row bottom-margin top-margin">
      <div class="col-lg-6">
        <div class="form-group">
          <label for="paymentPreferenceSelected_Input">
            Principal maturity preference <strong class="text-info">*</strong>
          </label>

          <select id="paymentPreferenceSelected_Input"
            name="paymentPreferenceSelected_Input"
            v-model="paymentPreferenceSelected"
            class="form-control">
            <option :value="paymentPreferences.DONATE.name">
              {{ paymentPreferences.DONATE.label }}
            </option>

            <option :value="paymentPreferences.PAYOUT.name">
              {{ paymentPreferences.PAYOUT.label }}
            </option>

            <option :value="paymentPreferences.REINVEST.name">
              {{ paymentPreferences.REINVEST.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="form-group">
          <label for="interestPreferenceSelected_Input">
            Interest payment preference <strong class="text-info">*</strong>
          </label>

          <select id="interestPreferenceSelected_Input"
            name="interestPreferenceSelected_Input"
            v-model="interestPreferenceSelected"
            class="form-control">
            <option :value="paymentPreferences.DONATE.name">
              {{ paymentPreferences.DONATE.label }}
            </option>

            <option :value="paymentPreferences.PAYOUT.name">
              {{ paymentPreferences.PAYOUT.label }}
            </option>

            <option :value="paymentPreferences.REINVEST.name">
              {{ paymentPreferences.REINVEST.label }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="panel-subtitle bottom-margin">
      Note Restrictions
    </div>
        <div
          class="checkbox c-checkbox bottom-margin"
          >
          <label>
            <input
              type="checkbox"
              id="notesRestriction_Input"
              @change="handleNotesRestrictionChange"
              v-model="redemptionRestrictionSelected"
              >
            <span class="fa fa-check"></span>
             Enable Redemptions with Upcoming Transactions
          </label>
        </div>

    <div class="panel-subtitle bottom-margin">
      General Communication Preferences
    </div>

    <div class="row bottom-margin top-margin" v-if="communicationPreferences.EMAIL !== undefined">
      <div class="col-lg-6">

        <div class="row">
          <div class="col-sm-6">
            <div v-bind:class="communicationPreferenceSelected === communicationPreferences.EMAIL.name ?
              'radio-item' : 'radio-item radio-item-unselected'">
              <input
                id="communicationPreference_Email"
                name="communicationPreference_Email"
                type="radio"
                v-bind:value="communicationPreferences.EMAIL.name"
                v-model="communicationPreferenceSelected" />
              <label for="communicationPreference_Email">{{ communicationPreferences.EMAIL.label }}</label>
            </div>
          </div>

          <div class="col-sm-6">
            <div v-bind:class="communicationPreferenceSelected === communicationPreferences.SNAIL_MAIL.name ?
              'radio-item' : 'radio-item radio-item-unselected'">
              <input
                id="communicationPreference_SnailMail"
                name="communicationPreference_SnailMmail"
                type="radio"
                v-bind:value="communicationPreferences.SNAIL_MAIL.name"
                v-model="communicationPreferenceSelected" />
              <label for="communicationPreference_SnailMail">{{ communicationPreferences.SNAIL_MAIL.label }}</label>
            </div>
          </div>
        </div>

      </div>
      <div class="col-lg-6"></div>
    </div>

    <div class="panel-subtitle bottom-margin">
      Specific Communication Preferences
    </div>

    <div class="row bottom-margin top-margin">
      <div class="col-lg-6">
        <div class="panel-subtitle">
          1099
        </div>
        <div class="checkbox c-checkbox">
          <label>
            <input
              type="checkbox"
              id="form1099_email"
              name="form1099_email"
              v-model="form1099Email"
              @change="handleForm1099EmailChange">
            <span class="fa fa-check"></span>
            Email
          </label>
        </div>
        <div class="checkbox c-checkbox">
          <label>
            <input
              type="checkbox"
              id="form1099_snailmail"
              name="form1099_snailmail"
              v-model="form1099SnailMail"
              @change="handleForm1099SnailMailChange">
            <span class="fa fa-check"></span>
            Snail Mail
          </label>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="panel-subtitle">
          Impact Report
        </div>
        <div class="checkbox c-checkbox">
          <label>
            <input
              type="checkbox"
              id="impactReport_email"
              name="impactReport_email"
              v-model="impactReportEmail"
              @change="handleImpactReportEmailChange">
            <span class="fa fa-check"></span>
            Email
          </label>
        </div>
        <div class="checkbox c-checkbox">
          <label>
            <input
              type="checkbox"
              id="impactReport_snailmail"
              name="impactReport_snailmail"
              v-model="impactReportSnailMail"
              @change="handleImpactReportSnailMailChange">
            <span class="fa fa-check"></span>
            Snail Mail
          </label>
        </div>
      </div>
    </div>

    <div class="panel-subtitle bottom-margin top-margin">
      Impact preferences
    </div>

    <div class="row top-margin bottom-margin">
      <div class="col-sm-6">
        <div class="panel-subtitle">
          Displayed
        </div>
      </div>

      <div class="col-sm-6">
        <div class="panel-subtitle">
          Non displayed
        </div>
      </div>
    </div>

    <div class="line-separator"></div>

    <div class="row" v-if="displayedPreferences.length > 0 && nonDisplayedPreferences.length > 0">
      <div class="col-sm-6">
        <div class="checkbox c-checkbox">
          <label>
            <input
            type="checkbox"
            @change="onChangeSelectImpactPreference"
            :id="displayedPreferences[indexOfGeneralPreference].id"
            :value="displayedPreferences[indexOfGeneralPreference].id"
            v-model="displayedPreferences[indexOfGeneralPreference].isSelected" :disabled=false>
            <span class="fa fa-check"></span>
            Where Calvert Impact Capital sees the most need and opportunity
          </label>
        </div>

        <div class="checkbox c-checkbox"
          v-for="(preference, index) in displayedPreferences"
          v-bind:key="index"
          v-if="!isGeneralPreference(index) && !isOtherPreference(index)">
          <label>
            <input type="checkbox"
              :id="preference.id"
              :value="preference.id"
              @change="onChangeSelectImpactPreference"
              v-model="preference.isSelected" :disabled=false>
            <span class="fa fa-check"></span>
            {{ preference.preferenceText }}
          </label>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="checkbox c-checkbox"
          v-for="(preference, index) in nonDisplayedPreferences"
          v-bind:key="index">
          <label>
            <input type="checkbox"
              :id="preference.id"
              :value="preference.id"
              @change="onChangeSelectImpactPreference"
              v-model="preference.isSelected" :disabled=false>
            <span class="fa fa-check"></span>
            {{ preference.preferenceText }}
          </label>
        </div>
      </div>
    </div>

    <div class="row top-margin bottom-margin">
      <div class="col-sm-6">
        <RestrictedSingleInput
          @inputUpdated="selectOtherPreference"
          :dual="true"
          :input="other"
          :limit="50"
          :warningLimit="29"
          fieldLabel="Other"
          instructionsLabel="Make sure your text doesn't exceed 50 characters."
          :placeholderText="'Enter your preference here...'" />
      </div>

      <div class="col-sm-6">
      </div>
    </div>

    <div class="row top-margin">
      <div class="col-md-2">
        <button type="submit" class="btn btn-default btn-lg button-submit" @click="showConfirmationModal">Submit preferences</button>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import {
  HIDE_QUESTION_MODAL,
  SET_ERRORS_MODAL_INFO,
  SHOW_ERRORS_MODAL,
  SHOW_QUESTION_MODAL,
} from '@/store/mutation-types';

import { Constants } from '@/data/static/constants';
import { Events } from '@/data/static/events';
import { logAction, logglyTags } from '@/util';
import logActions from '@/data/static/logActions';
import Question from '@/components/modals/Question';
import RestrictedSingleInput from '@/components/formControls/RestrictedSingleInput';

export default {
  name: 'AccountPreferences',
  props: [
    'accountId',
    'communicationPreference',
    'communication1099Preference',
    'communicationImpactReportPreference',
    'interestPreference',
    'paymentPreference',
    'user',
    'redemptionRestriction',
  ],
  data() {
    return {
      communicationPreferenceSelected: null,
      redemptionRestrictionSelected: false,
      counterTextColor: 'green-counter',
      displayedPreferences: [],
      form1099Email: true,
      form1099SnailMail: false,
      impactReportEmail: true,
      impactReportSnailMail: false,
      indexOfGeneralPreference: 0,
      indexOfOtherPreference: 0,
      interestPreferenceSelected: null,
      nonDisplayedPreferences: [],
      other: '',
      paymentPreferenceSelected: null,
      reservedPreferenceCodes: null,
      addPreferences: [],
      removePreferences: [],
      otherText: null,
      otherTextId: null,
      accountImpactPreferencesIds: [],
      impactPreferencesIds: [],
    };
  },
  async beforeMount() {
    this.communicationPreferenceSelected = this.communicationPreference;
    this.redemptionRestrictionSelected = !this.redemptionRestriction;
    this.interestPreferenceSelected = this.interestPreference;
    this.paymentPreferenceSelected = this.paymentPreference;
    if (this.communication1099Preference === 'BOTH') {
      this.form1099Email = true;
      this.form1099SnailMail = true;
    } else if (this.communication1099Preference === 'EMAIL') {
      this.form1099Email = true;
      this.form1099SnailMail = false;
    } else if (this.communication1099Preference === 'SNAIL-MAIL') {
      this.form1099Email = false;
      this.form1099SnailMail = true;
    }
    if (this.communicationImpactReportPreference === 'BOTH') {
      this.impactReportEmail = true;
      this.impactReportSnailMail = true;
    } else if (this.communicationImpactReportPreference === 'EMAIL') {
      this.impactReportEmail = true;
      this.impactReportSnailMail = false;
    } else if (this.communicationImpactReportPreference === 'SNAIL-MAIL') {
      this.impactReportEmail = false;
      this.impactReportSnailMail = true;
    }

    this.hideQuestionModal();
    this.initialize();
  },
  methods: {
    ...mapActions('account', [
      'getAccountImpactPreferences',
      'updateAccount',
      'updateAccountPreferences',
      'updateAccountImpactPreferences',
    ]),
    ...mapActions('impactPreferences',
      ['getImpactPreferences',
        'getSeparatedDisplayedAndNonDisplayedPreferencesAdmin',
      ]),
    ...mapMutations('errors', {
      showErrorsModal: SHOW_ERRORS_MODAL,
      setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
    }),
    ...mapMutations('question', {
      hideQuestionModal: HIDE_QUESTION_MODAL,
      showQuestionModal: SHOW_QUESTION_MODAL,
    }),
    handleNotesRestrictionChange(event) {
      this.redemptionRestrictionSelected = event.target.checked;
    },
    handleForm1099EmailChange(event) {
      this.form1099Email = event.target.checked;
    },
    handleForm1099SnailMailChange(event) {
      this.form1099SnailMail = event.target.checked;
    },
    handleImpactReportEmailChange(event) {
      this.impactReportEmail = event.target.checked;
    },
    handleImpactReportSnailMailChange(event) {
      this.impactReportSnailMail = event.target.checked;
    },
    onChangeSelectImpactPreference(event) {
      const { checked, value: preferenceId } = event.target;
      const parsedPreferenceId = Number(preferenceId);
      const belongsToAccount = this.accountImpactPreferencesIds.includes(parsedPreferenceId);
      if (checked && !belongsToAccount) {
        this.addPreferences.push(parsedPreferenceId);
      } else if (!checked && belongsToAccount) {
        this.removePreferences.push(parsedPreferenceId);
      } else if (checked && belongsToAccount) {
        this.removePreferences = this
        .removePreferences
        .filter(rp => rp !== parsedPreferenceId);
      } else if (!checked && !belongsToAccount) {
        this.addPreferences = this
        .addPreferences
        .filter(rp => rp !== parsedPreferenceId);
      }
    },
    createPayload() {
      const displayedPreferenceIds = this.displayedPreferences
        .filter(preference => preference.isSelected)
        .map(preference => preference.id);

      const nonDisplayedPreferenceIds = this.nonDisplayedPreferences
        .filter(preference => preference.isSelected)
        .map(preference => preference.id);

      const principalPreference = this.paymentPreferenceSelected === null ?
        this.paymentPreference : this.paymentPreferenceSelected;

      const interestPreference = this.interestPreferenceSelected === null ?
        this.interestPreference : this.interestPreferenceSelected;

      const communication1099Preference = this.getCommunicationPreferenceValue(
        this.form1099Email, this.form1099SnailMail,
      );

      const communicationImpactReportPreference = this.getCommunicationPreferenceValue(
        this.impactReportEmail, this.impactReportSnailMail,
      );

      return {
        communicationPreference: this.communicationPreferenceSelected,
        redemptionRestriction: !this.redemptionRestrictionSelected,
        interestPreference,
        otherText: this.other,
        principalPreference,
        preferences: displayedPreferenceIds.concat(nonDisplayedPreferenceIds),
        userId: this.user.id,
        communication1099Preference,
        communicationImpactReportPreference,
      };
    },
    getCommunicationPreferenceValue(email, snailMail) {
      if (email && snailMail) {
        return 'BOTH';
      }
      if (email) {
        return 'EMAIL';
      }
      if (snailMail) {
        return 'SNAIL-MAIL';
      }
      return null;
    },
    async initialize() {
      this.$emit(Events.IMPACT_PREFERENCES_LOADING_STARTED);
      try {
        this.reservedPreferenceCodes = { ...this.reservedImpactPreferenceCodes };
        const [accountImpactPreferences, impactPreferences] = await Promise.all([
          this.getAccountImpactPreferences(this.accountId),
          this.getImpactPreferences(),
        ]);
        this.accountImpactPreferencesIds = accountImpactPreferences.map(aip => aip.id);
        this.impactPreferencesIds = impactPreferences.map(ip => ip.id);
        const separatedDisplayedAndNonDisplayedImpactPreferences =
        await this.getSeparatedDisplayedAndNonDisplayedPreferencesAdmin({
          accountImpactPreferences,
          impactPreferences,
        });
        this.setDisplayedPreferences({
          displayedPreferences: separatedDisplayedAndNonDisplayedImpactPreferences
          .displayedPreferences,
          reservedPreferenceCodes: this.reservedPreferenceCodes,
        });
        this.setOtherText({
          displayedPreferences: separatedDisplayedAndNonDisplayedImpactPreferences
          .displayedPreferences,
          reservedPreferenceCodes: this.reservedPreferenceCodes,
        });
        this.setNonDisplayedPreferences({
          nonDisplayedPreferences: separatedDisplayedAndNonDisplayedImpactPreferences
          .nonDisplayedPreferences,
        });
      } catch (error) {
        this.setErrorsModalInfo(['Something went wrong. Please try again.']);
        this.showErrorsModal();

        logAction({
          user: this.user.id,
          level: 'error',
          action: logActions.VIEW_INVESTOR_IMPACT_PREFERENCES.name,
          message: error.message,
          stack: error.stack,
          tags: [logglyTags.auth0],
        });
      } finally {
        this.$emit(Events.IMPACT_PREFERENCES_LOADING_SUCCEED);
      }
    },
    isGeneralPreference(index) {
      return (
        this.reservedPreferenceCodes !== null &&
        this.displayedPreferences[index] !== undefined &&
        this.displayedPreferences[index].code === this.reservedPreferenceCodes.general
      );
    },
    isOtherPreference(index) {
      return (
        this.reservedPreferenceCodes !== null &&
        this.displayedPreferences[index] !== undefined &&
        this.displayedPreferences[index].code === this.reservedPreferenceCodes.other
      );
    },
    selectOtherPreference(value) {
      const otherPreference = this.displayedPreferences[this.indexOfOtherPreference];
      otherPreference.isSelected = (value.trim() !== '');
      otherPreference.otherText = value.trim();
      this.other = value;
      this.otherText = otherPreference.otherText;
      this.otherTextId = otherPreference.id;
    },
    setDisplayedPreferences({ displayedPreferences, reservedPreferenceCodes }) {
      this.displayedPreferences = displayedPreferences;

      this.indexOfGeneralPreference = this.displayedPreferences.findIndex(preference =>
        preference.code === reservedPreferenceCodes.general);

      this.indexOfOtherPreference = this.displayedPreferences.findIndex(preference =>
        preference.code === reservedPreferenceCodes.other);
    },
    setNonDisplayedPreferences({ nonDisplayedPreferences }) {
      this.nonDisplayedPreferences = nonDisplayedPreferences;
    },
    setOtherText({ displayedPreferences, reservedPreferenceCodes }) {
      const otherPreference = displayedPreferences.find(
        preference => preference.code === reservedPreferenceCodes.other,
      );

      const { otherText } = otherPreference;

      if (otherText) {
        const length = otherText.length > 50 ? 50 : otherText.length;
        this.other = otherText.substring(0, length);
        this.setOtherTextColor();
      }
    },
    setOtherTextColor() {
      if (this.other.length <= 29) {
        this.counterTextColor = 'green-counter';
      } else if (this.other.length > 29 && this.other.length <= 49) {
        this.counterTextColor = 'yellow-counter';
      } else if (this.other.length > 49) {
        this.counterTextColor = 'red-counter';
      }
    },
    showConfirmationModal() {
      this.showQuestionModal({
        title: Constants.adminPreferences.modalTitle,
        question: Constants.adminPreferences.modalQuestion,
        yesButtonText: Constants.adminPreferences.modalYesButtonText,
        method: this.saveInvestorImpactPreferences,
      });
    },
    async saveInvestorImpactPreferences() {
      try {
        this.hideQuestionModal();
        this.$emit(Events.UPDATE_IMPACT_PREFERENCES_STARTED);
        const payload = this.createPayload();

        await this.updateAccount({
          accountId: this.accountId,
          payload: {
            redemptionRestriction: payload.redemptionRestriction,
            communicationPreference: payload.communicationPreference,
            communication1099Preference: payload.communication1099Preference,
            communicationImpactReportPreference: payload.communicationImpactReportPreference,
          },
        });
        await this.updateAccountPreferences({
          accountId: this.accountId,
          payload: {
            interestPreference: payload.interestPreference,
            paymentPreference: payload.principalPreference,
          },
        });
        await this.updateAccountImpactPreferences({
          accountId: this.accountId,
          payload: {
            addPreferences: this.addPreferences,
            removePreferences: this.removePreferences,
            otherText: this.otherText,
            otherId: this.otherTextId,
          },
        });
        this.addPreferences = [];
        this.removePreferences = [];
        this.$emit(Events.UPDATE_IMPACT_PREFERENCES_SUCCEED);
        await this.initialize();
      } catch (error) {
        this.$emit(Events.UPDATE_IMPACT_PREFERENCES_FAILED);
        this.setErrorsModalInfo(['Something went wrong. Please try again.']);
        this.showErrorsModal();
        logAction({
          message: 'Something went wrong while trying to save investor preferences',
          stack: error.stack || 'NA',
          level: 'error',
        });
      }
    },
  },
  computed: {
    ...mapState('app', [
      'communicationPreferences',
      'paymentPreferences',
    ]),
    ...mapState('app', [
      'reservedImpactPreferenceCodes',
    ]),
    ...mapState('question', ['display']),
    ...mapState('errors', ['isVisibleErrorsModal']),
    selectedPreferences() {
      return this.preferences
        .filter(preference => preference.isSelected)
        .map(preference => ({
          id: preference.id,
          otherText: preference.otherText,
        }));
    },
  },
  watch: {
    other(value) {
      this.selectOtherPreference(value);
    },
  },
  components: {
    question: Question,
    RestrictedSingleInput,
  },
};
</script>

<style scoped>
  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }

  label {
    color: #888;
  }

  .top-margin {
    margin-top: 2%;
  }

  .panel-title {
    position: relative;
    width: 100%;
    padding-bottom: 20px;
    border-bottom: 1px dashed #eee;
  }

  .checkbox + .checkbox {
    margin-top: 20px;
  }

  .checkbox {
    cursor: default;
  }

  .checkbox label {
    position: relative;
    padding-left: 40px;
    cursor: pointer;
  }

  .c-checkbox:hover span {
    border-color: #cccccc;
  }

  .c-checkbox label:hover span {
    border-color: #137d8f;
  }

  .c-checkbox input:focus + span {
    border-color: #137d8f;
  }

  .checkbox .fa-check {
    position: absolute;
    margin: 0;
    left: 0;
  }

  .checkbox-disabled {
    outline: 1px solid red;
  }

  .checkbox p {
    margin-left: 40px;
    display: inline-block;
    cursor: text;
    color: #929292;
  }

  .checkbox-link {
    margin-left: 4px;
    display: inline-block;
    color: #137d8f;
    opacity: 0.75;
    transition: color 0.4s ease-in-out;
  }

  .checkbox-link:hover,
  .checkbox-link:focus {
    opacity: 1;
  }

  .extra-option {
    padding: 20px 0;
  }

  .extra-option textarea {
    resize: vertical;
  }

  .empty-state {
    margin: 0 auto;
    max-width: 740px;
    text-align: center;
    padding: 40px 0;
  }

  .empty__icon {
    font-size: 120px;
  }

  .empty__title {
    font-size: 28px;
    margin-bottom: 20px;
  }
  form.row {
    padding: 0 15px;
  }
  input.warning {
    border-color: #ffd814;
  }
  input.warning-error {
    border-color: #ff8116;
  }
  .panel-subtitle {
    font-weight: bold;
    font-size: 16px;
  }

  .green-counter {
    color: #558C1D;
  }

  .yellow-counter {
    color: #E58A2D;
  }

  .red-counter {
    color: #8C1D1D;
  }

  .radio-item label {
    color: #666;
    font-weight: normal;
    padding-left: 25px;
    padding-top: 5px;
    cursor: pointer;
    overflow: visible;
  }
  .radio-item label:before {
    content: " ";
    display: inline-block;
    position: absolute;
    top: 5px;
    left: 0px;
    margin: 0 5px 0 0;
    width: 20px;
    height: 20px;
    border-radius: 11px;
    background-color: transparent;
  }
  .radio-item-unselected label:before {
    border: 2px solid #d3d3d3;
  }
  .radio-item input[type=radio]:checked+label:after {
    border-radius: 5px;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 10px;
    left: 4.85px;
    right: auto;
    margin: auto;
    content: "";
    display: block;
  }
</style>



// WEBPACK FOOTER //
// AccountPreferences.vue?d2bee5ec